(function ($) {
$(document).ready(function () {
	if(window.plyr) {
		plyr.setup(document.querySelectorAll('.videoPlayer'));
	}

	// Pagination code
	$('.bloggExcerptList').on('click', '.wp-pagenavi a', function(e) {
	e.preventDefault();
	var href = $(this).attr('href');
	$.get(href,{'ajax': 'y'}, function(r) {
		$('.bloggExcerptList__blogg').html(r);
		$('html, body').animate({
			scrollTop: $(".bloggExcerptList").offset().top
		}, 1000);
	}, 'html');
	});

	// Fix to Edge
	if (!Modernizr.objectfit) {
		$(".image").each(function () {
			var $container = $(this),
				imgUrl = $container.find("img").prop("src");

			if (imgUrl) {
				$container.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	//Workshop modal overlay
	$('.btn__workshop').on('click', function (e) {
		$('.js-modal-workshop').addClass("modal--active");
		window.addEventListener('click', closeModal, true);
	});

	// Generic function to close the modal
	function closeModal(e) {
		if ($(e.target).hasClass('modal--active') || $(e.target).hasClass('formWorkshop__close')) {
			$('.modal').removeClass("modal--active");
			window.removeEventListener('click', closeModal, true);
		}
	}


	//add event handler for the contact form
	$(document).on('click', '.js-contact', function(e) {
		e.preventDefault();
		var $btn = $(this);
		var $form = $btn.closest('form');
		$form.removeClass('error success').find('.message').detach(); //reset
		var id = $form.find('input[name=_wpcf7]').val();
		if($form[0].checkValidity()) {
			/*$.post('/wp-json/contact-form-7/v1/contact-forms/' + id + '/feedback', $form.serialize(), function(r) {
				$form.append('<p class="message message--black">' + r.message + '</p>');
				if(r.status === 'mail_sent') {
					$form.addClass('success');
				} else if(r.status === 'mail_failed') {
					$form.addClass('error');
				} else if(r.status === 'validation_failed') { //because apparently at least FF doesn't validate as well as wpfc7
					$form.addClass('error');
				}
			});*/
			$.ajax({
				url: '/wp-json/contact-form-7/v1/contact-forms/' + id + '/feedback',
				data: $form.serialize(),
				method: 'POST',
				success: function(r){
					$form.append('<p class="message message--black">' + r.message + '</p>');
					if(r.status === 'mail_sent') {
						$form.addClass('success');
					} else if(r.status === 'mail_failed') {
						$form.addClass('error');
					} else if(r.status === 'validation_failed') { //because apparently at least FF doesn't validate as well as wpfc7
						$form.addClass('error');
					}
				},
				error: function(err){
					console.log(err);
				}
			});
		} else {
			$form.addClass('error');
			$form.append('<p class="form__errorMessage message message--black">Kontrollera att du fyllt i alla fält korrekt</p>');
		}
	});

	//when someone tries to subscribe in .js-subscribe-footer, pop up a modal where they accept GDPR and fill a captcha
	var $footerForm = $('.js-subscribe-footer');
	var $subscriptionModal;
	var getSubscriptionModal = function() {
		//get the form and build the modal
		$.get('/wp-content/themes/occident2018/helpers/getFormAjax.php?formid=' + $footerForm.data('cformid'), function(r) {
			$footerForm.off('focus', 'input', getSubscriptionModal);
			$('body').append(r);
			$subscriptionModal = $('.js-modal-' + $footerForm.data('cformid'));
			//recaptcha integration:
			$.getScript('https://www.google.com/recaptcha/api.js');
		});
	};
	$footerForm.on('focus', 'input', getSubscriptionModal);
	var popSubscriptionModal = function() {
		if($subscriptionModal && $subscriptionModal.length > 0) {
			$subscriptionModal.addClass('modal--active');
			window.addEventListener('click', closeModal, true);
			var inpEmail = $subscriptionModal.find('input[type=email]');
			var $this = $(this);
			if($this.is('button')) {
				inpEmail.val($this.siblings('input[type=email]').val());
			} else {
				inpEmail.val($(this).val());
			}
			//note: it's impossible to set focus to an input before it is "visible" (according to the browser). So, wait until the transition "in" is complete before setting focus to the new "copied" input
			$subscriptionModal.on('transitionend', function() {
				inpEmail.focus();
			});
		}
	};
	$footerForm.on('click','button', popSubscriptionModal);
	$footerForm.on('keypress','input', function(e) {
		if(e.key === 'Enter') {
			e.preventDefault();
			popSubscriptionModal.apply(this);
		}
	});
	//submission
	$(document).on('click', '.js-subscribe', function(e) {
		e.preventDefault();
		var $btn = $(this);
		var $form = $btn.closest('form');
		$form.removeClass('error success').find('.message').detach(); //reset
		var id = $form.find('input[name=_wpcf7]').val();
		if($form[0].checkValidity()) {
			$.post('/wp-json/contact-form-7/v1/contact-forms/' + id + '/feedback', $form.serialize(), function(r) {
				$form.append('<p class="message message--black">' + r.message + '</p>');
				switch(r.status) {
					case 'mail_sent':
						$form.addClass('success');
						break;
					case 'mail_failed':
					case 'validation_failed':
					case 'acceptance_missing':
						$form.addClass('error');
						grecaptcha.reset();//re-init recaptcha on submission. TODO: do we actually need to as it's an ajax post?
				}
			});
		} else {
			$form.addClass('error');
			$form.append('<p class="form__errorMessage message message--black">Kontrollera att du fyllt i alla fält korrekt</p>');
		}
	});
});
})(jQuery);
